var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareHeroImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#E3E9FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2119_191411",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#E3E9FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2119_191411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6444 50.3731L61.5338 44.0736L61.8125 43.4307L64.1738 43.7354L62.6444 50.3731Z",
    fill: "url(#paint0_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1829 37.7664L60.7658 44.5491L59.4043 38.7249L72.1498 32.5097C72.9175 32.1354 73.8344 32.569 74.0321 33.3999C74.4373 35.1032 73.6882 36.8722 72.1829 37.7664Z",
    fill: "url(#paint1_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4623 112.794L14.9997 109.241L31.616 75.9865L45.2047 46.4518L62.8108 49.3662L64.5851 62.0635L61.465 70.5051C57.3283 81.9655 51.7851 84.7517 49.8851 84.7818L36.4623 112.794Z",
    fill: "url(#paint2_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7749 76.63L45.7749 69.5447L58.3485 72.5311L45.7749 76.63Z",
    fill: "url(#paint3_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1504 25.5488C35.1452 24.1137 36.3044 22.9461 37.7394 22.9409L60.798 22.8574C62.2331 22.8522 63.4007 24.0114 63.4059 25.4465L63.568 70.2172C63.5732 71.6522 62.414 72.8198 60.9789 72.825L37.9203 72.9085C36.4852 72.9137 35.3177 71.7545 35.3125 70.3195L35.1504 25.5488Z",
    fill: "url(#paint4_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4282 26.3525C36.4245 25.3072 37.2688 24.4567 38.3141 24.4529L46.0166 24.4251C46.0852 24.4248 46.141 24.4802 46.1413 24.5488L46.1436 25.1817C46.1455 25.7043 46.5707 26.1265 47.0934 26.1246L51.6803 26.108C52.203 26.1061 52.6251 25.6809 52.6232 25.1582L52.6209 24.5254C52.6207 24.4568 52.6761 24.4009 52.7447 24.4007L60.4472 24.3728C61.4925 24.369 62.343 25.2134 62.3468 26.2587L62.5016 69.034C62.5054 70.0793 61.6611 70.9297 60.6158 70.9335L38.4826 71.0136C37.4373 71.0174 36.5869 70.1731 36.5831 69.1278L36.4282 26.3525Z",
    fill: "url(#paint5_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.681 42.1102C54.681 43.3561 53.671 44.3661 52.4251 44.3661C51.7637 44.3661 51.1687 44.0814 50.7561 43.6281L48.6029 44.5894C48.6437 44.759 48.6652 44.936 48.6652 45.1181C48.6652 45.381 48.6202 45.6336 48.5374 45.8684L50.6058 46.7917C51.0165 46.2329 51.6784 45.8701 52.4251 45.8701C53.671 45.8701 54.681 46.8801 54.681 48.126C54.681 49.372 53.671 50.382 52.4251 50.382C51.1791 50.382 50.1692 49.372 50.1692 48.126C50.1692 47.9845 50.1821 47.846 50.2071 47.7116L47.994 46.7236C47.5866 47.1258 47.027 47.374 46.4093 47.374C45.1633 47.374 44.1533 46.3641 44.1533 45.1181C44.1533 43.8721 45.1633 42.8622 46.4093 42.8622C47.1136 42.8622 47.7426 43.185 48.1563 43.6908L50.2614 42.7508C50.2013 42.5476 50.1692 42.3327 50.1692 42.1102C50.1692 40.8642 51.1791 39.8542 52.4251 39.8542C53.671 39.8542 54.681 40.8642 54.681 42.1102Z",
    fill: "#3EE78D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0581 94.8892L41.1372 89.8901C40.5632 89.1582 40.7056 88.0971 41.4522 87.5424C43.2034 86.2416 45.6176 86.309 47.2935 87.7055L48.1633 88.4304L45.0581 94.8892Z",
    fill: "url(#paint6_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2312 77.7175L32.0376 78.1243L33.0718 45.3011C33.1031 44.3052 34.0045 43.5648 34.9876 43.7276C37.2423 44.1008 38.9486 45.9698 39.086 48.2511C39.3324 52.342 39.5976 57.7467 39.577 61.1976C47.0473 65.1906 47.1258 73.8746 46.2312 77.7175Z",
    fill: "url(#paint7_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.119 69.4521L65.0803 61.199L66.1208 61.3712C67.2763 61.5625 68.234 62.3716 68.6155 63.4789C68.9609 64.4809 68.7859 65.5891 68.1486 66.436L62.4813 73.9675C61.8995 74.7407 60.7262 74.7008 60.1983 73.8897C59.3247 72.5476 59.2939 70.8246 60.119 69.4521Z",
    fill: "url(#paint8_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6276 61.5315L62.1001 66.1668L64.6872 61.4237L65.334 61.1003L66.6276 61.5315Z",
    fill: "url(#paint9_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5146 60.763L64.8814 51.9492L66.0674 52.1455C67.3009 52.3497 68.3255 53.2092 68.741 54.3885C69.1252 55.4787 68.9341 56.689 68.2329 57.6079L62.0618 65.6939C61.4331 66.5177 60.1798 66.4759 59.6074 65.612C58.6388 64.1504 58.6027 62.2606 59.5146 60.763Z",
    fill: "url(#paint10_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5197 52.2611L61.9922 56.7887L64.5793 52.0455L65.4417 51.9377L66.5197 52.2611Z",
    fill: "url(#paint11_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.466 91.4046C45.0479 93.456 47.033 96.1089 48.2233 97.9447C49.5114 99.9315 57.1934 108.103 61.1631 113.438C61.4984 113.493 61.7811 116.469 61.7811 116.469L81.8272 117.695L79.9066 108.961C77.6384 92.3213 76.5006 87.8724 74.3855 82.7664C74.0624 81.9866 73.3462 81.4415 72.5108 81.3207L70.7598 81.0674C70.1145 80.9741 69.4635 81.1943 69.0075 81.6602L68.9793 81.6112C68.6162 80.9794 67.9887 80.544 67.2698 80.425L66.0559 80.2241C65.1059 80.0668 64.1619 80.5351 63.7123 81.3866L63.3077 80.5502C63.0785 80.0765 62.6334 79.7437 62.1143 79.6577L59.5936 79.2405C58.7111 79.0944 57.8773 79.6914 57.7312 80.5739L57.6488 81.0719L55.0932 65.5906C54.8632 64.1974 53.5729 63.2353 52.1719 63.4124C50.7726 63.5894 49.7628 64.84 49.8846 66.2453L52.2418 93.4418L47.3814 88.0782C46.5326 87.1416 45.127 86.9654 44.0733 87.6636C42.822 88.4928 42.5493 90.2159 43.466 91.4046Z",
    fill: "url(#paint12_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3603 85.2503L69.0071 81.6603L69.5934 81.2405L69.3603 85.2503Z",
    fill: "url(#paint13_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0794 84.8919L63.7262 81.3019L64.2703 80.6168L64.0794 84.8919Z",
    fill: "url(#paint14_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6391 52.5216L64.0059 43.7078L65.1919 43.9041C66.4254 44.1083 67.45 44.9678 67.8655 46.147C68.2497 47.2372 68.0586 48.4476 67.3574 49.3664L61.1863 57.4524C60.5576 58.2762 59.3043 58.2344 58.7319 57.3706C57.7633 55.909 57.7272 54.0192 58.6391 52.5216Z",
    fill: "url(#paint15_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9598 84.8927L57.6065 80.8058L58.1506 80.1207L57.9598 84.8927Z",
    fill: "url(#paint16_linear_2119_191411)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7741 94.9073L50.8568 91.9198L51.5981 92.6454L52.1428 92.4772L51.789 88.3702L52.7741 94.9073Z",
    fill: "url(#paint17_linear_2119_191411)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2119_191411",
    x1: 62.0831,
    y1: 49.0611,
    x2: 62.817,
    y2: 44.6277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D216F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#1635AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2119_191411",
    x1: 67.2454,
    y1: 44.6146,
    x2: 67.2454,
    y2: 34.3473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2119_191411",
    x1: 40.8982,
    y1: 40.9117,
    x2: 21.7862,
    y2: 156.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3852B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2119_191411",
    x1: 51.3949,
    y1: 77.5984,
    x2: 57.1105,
    y2: 68.1975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2119_191411",
    x1: 50.2708,
    y1: 64.0533,
    x2: 50.2708,
    y2: 30.9696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D216F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#1635AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2119_191411",
    x1: 50.3014,
    y1: 62.7618,
    x2: 50.3014,
    y2: 31.9323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16329D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4A6CEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2119_191411",
    x1: 44.7107,
    y1: 93.4246,
    x2: 44.7107,
    y2: 87.9524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D216F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#1635AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2119_191411",
    x1: 39.9222,
    y1: 42.0605,
    x2: 36.2742,
    y2: 82.3535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#233C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#314BB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2119_191411",
    x1: 64.4526,
    y1: 74.5951,
    x2: 64.4526,
    y2: 63.3586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2119_191411",
    x1: 64.5091,
    y1: 65.2705,
    x2: 64.5091,
    y2: 61.9215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D216F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#1635AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2119_191411",
    x1: 64.2188,
    y1: 66.3637,
    x2: 64.2188,
    y2: 54.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2119_191411",
    x1: 64.4012,
    y1: 55.9304,
    x2: 64.4012,
    y2: 52.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D216F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#1635AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2119_191411",
    x1: 61.0422,
    y1: 116.627,
    x2: 68.1345,
    y2: 73.7824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2119_191411",
    x1: 69.0442,
    y1: 84.4817,
    x2: 69.4753,
    y2: 81.8771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D216F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#1635AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2119_191411",
    x1: 63.7706,
    y1: 84.0789,
    x2: 64.2293,
    y2: 81.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D216F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#1635AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2119_191411",
    x1: 63.3434,
    y1: 58.1223,
    x2: 63.3434,
    y2: 46.0316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2119_191411",
    x1: 57.6277,
    y1: 83.9879,
    x2: 58.1393,
    y2: 80.8973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D216F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#1635AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2119_191411",
    x1: 51.8574,
    y1: 93.6279,
    x2: 52.5362,
    y2: 89.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D216F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#1635AA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareHeroImg);
export default __webpack_public_path__ + "static/media/share-hero-img.75ef6cf33eaee40eeeff28347168a3bc.svg";
export { ForwardRef as ReactComponent };